"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIp = void 0;

var _trim = _interopRequireDefault(require("lodash/trim"));

var _normalizeIp = require("./normalize-ip");

var _parseIp = require("./parse-ip");

var _isIpValid = require("./is-ip-valid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description
 * returns new IP from the specified text and originalIp
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#updateIp
 * @param {skybase-components.sb-ipv4-input.utils#IpChunk} [originalIp=Array()]
 * @param {String} [text=""]
 * @param {Boolean} [false] If true, empty string can be returned as relevant value
 * @return {skybase-components.sb-ipv4-input.utils#IpChunk}
 */
var updateIp = function updateIp() {
  var originalIp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var text = arguments.length > 1 ? arguments[1] : undefined;
  var nullable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // Ability to update to empty value
  if (nullable && text === '') {
    return '';
  }

  var normalizedIp = (0, _normalizeIp.normalizeIp)((0, _trim.default)(text));

  if (normalizedIp === '' && text === '') {
    return [0, 0, 0, 0];
  }

  if (!(0, _isIpValid.isIpValid)(normalizedIp)) {
    return originalIp.length === 4 ? originalIp : [0, 0, 0, 0];
  }

  return (0, _parseIp.parseIp)(normalizedIp);
};

exports.updateIp = updateIp;
//# sourceMappingURL=update-ip.js.map